import type { FunctionalComponent } from '@stencil/core'
import { h } from '@stencil/core'
import { WidgetPanel, type WidgetPanelProps } from './WidgetPanel'

export const WidgetPanelOuter: FunctionalComponent<WidgetPanelProps> = ({ widgetType, widgetView, onWidgetTypeChange, onWidgetViewChange }) => {
  return (
    <div class="debug-toolbar-panel open">
      <div class="debug-toolbar-header">
        <h3>Widget Settings</h3>
      </div>
      <WidgetPanel
        widgetType={widgetType}
        widgetView={widgetView}
        onWidgetTypeChange={onWidgetTypeChange}
        onWidgetViewChange={onWidgetViewChange}
      />
    </div>
  )
}
